import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import CartLineItem from './CartLineItem';

function CartOverviewItem(props) {
  const { lineItem, ...other } = props;
  return (
    <CartLineItem finalPrice={lineItem.price} lineItem={lineItem} {...other} />
  );
}

CartOverviewItem.propTypes = {
  lineItem: PropTypes.object,
};

export default createFragmentContainer(CartOverviewItem, {
  lineItem: graphql`
    fragment CartOverviewItem_lineItem on LineItem {
      price
      ...CartLineItem_lineItem
    }
  `,
});
